document.addEventListener('DOMContentLoaded', () => {
    const burger = document.querySelector('.header__burger');
    const nav = document.querySelector('.header__navigation');
    const layerBackground = document.querySelector('.header__navigation-layer');
    const mobileSocial = document.querySelector('.header__social-mobile');
    const header = document.querySelector('.header');

    burger.addEventListener('click', () => {
        nav.classList.toggle('show')
        burger.classList.toggle('show')
        mobileSocial.classList.toggle('show')
        layerBackground.classList.toggle('show')
        header.classList.toggle('show')
    })

    layerBackground.addEventListener('click', () => {
        nav.classList.toggle('show')
        burger.classList.toggle('show')
        mobileSocial.classList.toggle('show')
        layerBackground.classList.toggle('show')
        header.classList.toggle('show')
    })


    //Геоимтрические фигуры на главной
    const figure_1 = document.querySelector('.geometric_1'),
        figure_2 = document.querySelector('.geometric_2'),
        figure_3 = document.querySelector('.geometric_3'),
        figure_4 = document.querySelector('.geometric_4'),
        figure_5 = document.querySelector('.geometric_5'),
        figure_6 = document.querySelector('.geometric_6'),
        figure_7 = document.querySelector('.geometric_7'),
        figure_8 = document.querySelector('.geometric_8');

    document.body.addEventListener('mousemove', function (event) {
        const
            x = event.pageX,
            y = event.pageY,
            x_figure = x / 25,
            y_figure = y / 25;


        figure_1.style.transform = `matrix(1, 0, 0, 1, ${-x_figure * 1.2}, ${y_figure})`;
        figure_2.style.transform = `matrix(1, 0, 0, 1, ${x_figure * 0.8}, ${-y_figure * 1.7})`;
        figure_3.style.transform = `matrix(1, 0, 0, 1, ${-x_figure * 1.5}, ${y_figure})`;
        figure_4.style.transform = `matrix(1, 0, 0, 1, ${-x_figure * 2}, ${-y_figure * 1.3})`;
        figure_5.style.transform = `matrix(1, 0, 0, 1, ${x_figure}, ${y_figure})`;
        figure_6.style.transform = `matrix(1, 0, 0, 1, ${-x_figure}, ${-y_figure * 1.4})`;
        figure_7.style.transform = `matrix(1, 0, 0, 1, ${x_figure}, ${y_figure})`;
        figure_8.style.transform = `matrix(1, 0, 0, 1, ${-x_figure}, ${-y_figure})`;
    });

    const rect1 = figure_1.getBoundingClientRect().top
    const rect2 = figure_2.getBoundingClientRect().top
    const rect3 = figure_3.getBoundingClientRect().top
    const rect4 = figure_4.getBoundingClientRect().top
    const rect5 = figure_5.getBoundingClientRect().top
    const rect6 = figure_6.getBoundingClientRect().top
    const rect7 = figure_7.getBoundingClientRect().top
    const rect8 = figure_8.getBoundingClientRect().top

    const figure = document.querySelectorAll('.chocko-ball');
    const rectFigure = []


    for (let i = 0; i < figure.length; i++) {
        rectFigure[i] = {
            'topF': figure[i].getBoundingClientRect().top,
            'leftF': figure[i].getBoundingClientRect().left,
        }
    }
    function setPositionFigureScroll(scroll) {
        for (let i = 0; i < figure.length; i++) {

            figure[i].style.top = `${rectFigure[i].topF + scroll}px`

        }
    }

    window.addEventListener('scroll', function (event) {
        if(window.scrollY > 10){
            document.querySelector('.header').classList.add('scrolling')
        } else {
            document.querySelector('.header').classList.remove('scrolling')
        }

        setPositionFigureScroll(window.scrollY)
    });
})